import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { WarningIcon } from '@repo/ui/icons'
import Modal from '@repo/ui/modal'
import Typography from '@repo/ui/typography'

type Props = {
  warnings: string[]
  isOpen: boolean
  isLoading: boolean
  onCancel: () => void
  onConfirm: () => void
}

// Identity document alerts shown before positioning a staff on a stay, they never block it
const IdDocumentWarningsModal = ({ warnings, isOpen, isLoading, onCancel, onConfirm }: Props) => (
  <Modal
    onCancel={onCancel}
    isOpen={isOpen}
    title="Attention"
    icon={WarningIcon}
    isLoading={isLoading}
    variant="confirmation"
    actionButtonsOptions={{
      confirmText: 'Continuer',
      cancelText: 'Annuler',
      onConfirm
    }}
  >
    <div className="flex flex-col gap-2">
      {warnings.map((warning) => (
        <Typography key={warning} variant="body-medium" color={tailwindColors.black.DEFAULT}>
          {warning}
        </Typography>
      ))}
    </div>
  </Modal>
)

export default IdDocumentWarningsModal
